var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectOffice1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2520,
    height: 1700,
    viewBox: "0 0 2520 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M2312 560H2346V959.5V994V1401H2267H1910V993.5V959.5V560H2312Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M2346.5 297V557.5L1910.5 559.5V1401H1528V1216V992.5H1518.5V615.5V593H1511V346.5H1502.5L1504.5 227.5H1911H1945H2346.5V297Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M1264 640V719.5H1128V959.5V993.5V1358V1399H1342L1427 1314V640H1264Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M703.5 186V227.5H1144.5V578H1196V640H1262.5V718.5H1128.5V1401H703.5V954.5H384.5V186H703.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectOffice1);
export default __webpack_public_path__ + "static/media/select-office-1.dfc89a3c.svg";
export { ForwardRef as ReactComponent };